import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../app/hooks';
import { FeatureEnum } from '../../../../services/data/impl/cube/cubeSlice';
import { Scan } from '../../../../services/entities/impl/blfApi/schemas/scan';
import {
  RanchPageViewEnum,
  setRanchFocusArea,
  setRanchPageView,
} from '../../../ranches/ranchesSlice';
import {
  ResetItemsEnum,
  resetSelectFields,
  setCurrBlockByID,
  setCurrCustomerByID,
  setCurrFeature,
  setCurrRanchByID,
  setCurrScanByID,
  setCurrYear,
} from '../../../select/selectSlice';

export const useScanCardEventHandlers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (scan: Scan, feature?: FeatureEnum) => {
      const { id, scanDate, blockID, ranchID, customerID } = scan;
      dispatch(setCurrCustomerByID(customerID));
      dispatch(setCurrRanchByID(ranchID));
      dispatch(setCurrBlockByID(blockID));
      dispatch(setCurrScanByID(id));
      dispatch(setCurrYear(scanDate.slice(0, 4)));
      dispatch(resetSelectFields([ResetItemsEnum.AllCubeRelatedFields]));
      dispatch(setRanchFocusArea(null));
      dispatch(setRanchPageView(RanchPageViewEnum.blockDetail));
      if (feature) {
        dispatch(setCurrFeature(feature));
      }
      navigate('/');
    },
    [dispatch, navigate]
  );

  return {
    handleOnClick,
  };
};
